import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import colors from 'styleguide/colors';
import {
  badgePaddingX,
  badgePaddingY,
  badgeFontSize,
  badgeBorderRadius,
} from 'styleguide/constants';

const solidBadge = (color) => `
  background-color: ${colors(color)};
  color: ${colors('white')};
`;

const lightBadge = (color) => `
  color: ${colors(color)};
  border: 1px solid ${colors(color)};
`;

const badgeStyle = ({ solid, color }) => (solid ? solidBadge(color) : lightBadge(color));

const Styled = styled.span`
  ${badgeStyle}

  display: inline-block;
  padding: ${badgePaddingY} ${badgePaddingX};
  font-size: ${badgeFontSize};
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: ${badgeBorderRadius};

  text-decoration: none;
`;

const Badge = React.forwardRef((props, ref) => <Styled ref={ref} {...props} />);

Badge.propTypes = {
  /** The color of the badge */
  color: PropTypes.string,
  /** Show a solid background or not */
  solid: PropTypes.bool,
};

Badge.defaultProps = {
  color: 'primary',
  solid: false,
};

export default Badge;
